module.exports = __webpack_public_path__ + "static/media/3.e1e46da6.jpg";